var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":_vm.viewBox}},[_c('g',[_c('path',{attrs:{"stroke":_vm.stroke,"fill":_vm.stroke,"d":"M 13 16.171875 L 18.363281 10.808594 L 19.777344 12.222656 L 12 20 L 4.222656 12.222656 L 5.636719 10.808594 L 11 16.171875 L 11 4 L 13 4 Z M 13 16.171875 "}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }